<template>
    <div>
        <div v-show="!root">Actions</div>
        <div v-for="(action, idx) in actions" :key="idx">
            <scraping_xpath :style="root ? '' : 'margin-left:30px'" :ref="'action-' + idx" />
            <b-button v-show="!root" variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
        </div>
        <b-button v-show="!root" variant="link" @click="add()"><i class="fas fa-plus"></i></b-button>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

	import library from "../../services/library.js";
    import scraping_xpath from "./scraping_xpath.vue"

    var clone = require("clone");
    
    export default {
        name: "scraping_actions",
		components: {
            scraping_xpath
		},
		props: {
            root: {
                default: false
            }
        },
        watch: 
        {
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),
                actions: []
			};
        },
        methods: {
            get_data()
            {
                return this.save()
            },
            save()
            {
                for (var i = 0; i < this.actions.length; i++)
                {
                    if (this.actions[i].name == "action_xpath")
                    {
                        this.actions[i].xpath = this.$refs['action-' + i][0].save();
                    }
                }

                console.log("this.actions")
                console.log(this.actions)
                

                var data = this.actions;

                return data;
            },
            async load(data)
            {
                var self = this;
                
                if (!data)
                {
                    return;
                }

                this.actions = data;

                await this.$nextTick();

                console.log("this.actions")
                console.log(this.actions)

                for (var i = 0; i < this.actions.length; i++)
                {
                    if (this.actions[i].name == "action_xpath")
                        await this.$refs['action-' + i][0].load(this.actions[i].xpath);
                }

            },
            add()
            {
                this.actions.push({
                    "name": "action_xpath"
                })
            },
            del(idx)
            {
                this.actions.splice(idx, 1);
            }
        },
        async mounted()
        {		
            if (this.root)
            {
                this.actions.push({
                    "name": "action_xpath"
                });
            }
        }
    }
</script>

<style scoped>
</style>